module.exports = __webpack_public_path__ + "img/02董占平.4f0f96ab.jpg";